import React from 'react'

const RecommendBadge = ({ className }) => (
  <svg className={className || 'RecommendBadge'} width="28px" height="28px" viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>Recommended</title>
    <g id="Signup-&amp;-Invite-Users" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Invite-Agents-01---Add-Manually" transform="translate(-252.000000, -280.000000)">
            <g id="badge-recommended" transform="translate(252.000000, 280.000000)">
                <path d="M27.9132609,13.9567826 C27.9132609,21.6646957 21.6646957,27.9132609 13.9564783,27.9132609 C6.24856522,27.9132609 7.10542736e-14,21.6646957 7.10542736e-14,13.9567826 C7.10542736e-14,6.24856522 6.24856522,7.10542736e-14 13.9564783,7.10542736e-14 C21.6646957,7.10542736e-14 27.9132609,6.24856522 27.9132609,13.9567826" id="Fill-4" fill="#FFEDC2"/>
                <polygon id="Fill-1" fill="#FF9C46" points="11.5104957 11.2911522 6.04349565 12.0839783 9.9994087 15.9318478 9.06566957 21.3650652 13.9553217 18.8000217 18.8452783 21.3650652 17.9112348 15.9318478 21.8674522 12.0839783 16.4004522 11.2911522 13.9553217 6.34793478"/>
            </g>
        </g>
    </g>
</svg>
)

export default RecommendBadge
